import { Divider, Stack, Text } from '@ltvco/refresh-lib/theme';
import { pluralizeString } from '@ltvco/refresh-lib/utils';
import DeleteIcon from '@mui/icons-material/Delete';

import { DeleteAllButton } from 'components/DeepSearch/components/ReportLibrary/components/ReportCountBar.styles';

interface ReportCountBarProps {
  count: number;
  label?: string;
  showDeleteAll?: boolean;
  disableDeleteAll?: boolean;
  onDeleteAll?: () => void;
}

export const ReportCountBar = ({
  count,
  label = 'viewed',
  showDeleteAll = false,
  disableDeleteAll = false,
  onDeleteAll,
}: ReportCountBarProps) => (
  <Stack direction="row" alignItems="center" spacing={1.5}>
    <Text variant="caption" color="text.secondary">
      {count} {pluralizeString('report', count)} {label}
    </Text>
    {showDeleteAll && (
      <>
        <Divider
          sx={{ borderColor: 'text.primary' }}
          orientation="vertical"
          flexItem
        />
        <DeleteAllButton
          type="button"
          variant="text"
          size="small"
          disabled={disableDeleteAll}
          onClick={onDeleteAll}
          startIcon={<DeleteIcon sx={{ fontSize: '14px' }} />}
          sx={{ color: 'text.primary' }}
        >
          Delete all
        </DeleteAllButton>
      </>
    )}
  </Stack>
);
